import { createTheme } from "@mui/material/styles";

export const adminTheme = createTheme({
  palette: {
    primary: {
      main: "#0069a7",
      dark: "#004d80",
      light: "#f0f7ff",
    },
    background: {
      default: "#f8fafc", // Fondo gris claro de toda la pantalla
      paper: "#ffffff",   // Fondo blanco de tarjetas, sidebar y header
    },
    text: {
      primary: "#1e293b",   // Texto principal oscuro (títulos)
      secondary: "#64748b", // Texto secundario gris (iconos, etiquetas)
    },
    divider: "#e2e8f0",     // Color de las líneas separadoras y bordes
    action: {
      hover: "#f8fafc",
      selected: "#0069a7",
    },
  },
  typography: {
    fontFamily: '"Montserrat", sans-serif,"Roboto"'
  },
  shape: {
    borderRadius: 8,
  },
});
